import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

/**
 * When a saved view is loaded, keep all graph state, but unmark current state as "being the loaded view"
 */
export const unbindView: GraphCommandFactory = (cmdContext) => {
  return () => {
    cmdContext.updateState((draft) => {
      draft.loadViewDialog.loadedView = null;
    });
  };
};
